// removed by extract-text-webpack-plugin
module.exports = {"container":"_2kCF0","borders":"U0l_H","box":"_2QQjh","label":"_3WT5p","arrow":"_1acLQ","option":"_3ZKun","overlay":"OcqRG","isScrollable":"_3qeU_","scrollable":"_7OmJ1","optionWrapper":"_3HabG","optionContent":"_3meoQ","hoverBackground":"_3ow39","separator":"_3pYVI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/select/select-desktop.scss
// module id = 851
// module chunks = 3 4 5 6 7